export const COMPARE_ENERGY_PLANS = 'COMPARE_ENERGY_PLANS'

export const comparePlans = (plans) => ({
  type: COMPARE_ENERGY_PLANS,
  payload: plans
})
